import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import ClinicTabContainer from '../modules/ClinicTabContainer';
import clinicService from '../../../services/clinic.service';
import Loading from '../../common/Loading';
import '../clinics.css';
const ClinicInfo = () => {
    const [clinic, setClinic] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { clinicId } = useParams();

    const fetchClinic = useCallback(() => {
        setIsLoading(true);
        setError(null);
        clinicService
            .getClinicById(clinicId)
            .then((res) => {
                setClinic(res.data);
            })
            .catch(() => {
                setError('Failed to load clinic details.');
                setClinic(null);
            })
            .finally(() => setIsLoading(false));
    }, [clinicId]);

    useEffect(() => {
        fetchClinic();
    }, [fetchClinic]);

    if (isLoading) {
        return (
            <div className="container-fluid">
                <div className="pagetitle">
                    <h1>
                        <i className="bi bi-hospital"></i> Clinic
                    </h1>
                </div>
                <Loading />
            </div>
        );
    }

    if (error || !clinic) {
        return (
            <div className="container-fluid">
                <div className="pagetitle d-flex justify-content-between align-items-center">
                    <h1>
                        <i className="bi bi-hospital"></i> Clinic
                    </h1>
                    <Link to="/clinics" className="btn btn-sm btn-outline-secondary">
                        <i className="bi bi-chevron-left me-1"></i>
                        Back to Clinics
                    </Link>
                </div>
                <div className="alert alert-warning border-0 shadow-sm">{error || 'Clinic not found.'}</div>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="pagetitle d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h1 className="mb-0">
                    <i className="bi bi-hospital"></i> {clinic.name}
                </h1>
                <Link to="/clinics" className="btn btn-sm btn-outline-secondary">
                    <i className="bi bi-chevron-left me-1"></i>
                    Back to Clinics
                </Link>
            </div>

            <Card className="clinic-detail-card shadow-sm border-0">
                <Card.Body className="p-3">
                    <ClinicTabContainer />
                </Card.Body>
            </Card>
        </div>
    );
};

export default ClinicInfo;
